<template>
  <div class="verification-wrapper">
    <div class="verification-card">
      <div v-if="loading" class="state-content">
        <div class="loading-spinner"></div>
        <p>Verifying your email...</p>
      </div>

      <div v-else-if="success" class="state-content">
        <div class="icon-circle success">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor">
            <path d="M229.66,77.66l-128,128a8,8,0,0,1-11.32,0l-56-56a8,8,0,0,1,11.32-11.32L96,188.69,218.34,66.34a8,8,0,0,1,11.32,11.32Z"></path>
          </svg>
        </div>
        <h2>Email Verified!</h2>
        <p>Your account has been successfully verified.<br>You can now access all features.</p>
        <button @click="goToLogin" class="action-btn">Go to Home</button>
      </div>

      <div v-else class="state-content">
        <div class="icon-circle error">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor">
            <path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm-16-80a8,8,0,0,1,8-8h16a8,8,0,0,1,0,16H120A8,8,0,0,1,112,136Zm8-64a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8v48a8,8,0,0,1-8,8H128a8,8,0,0,1-8-8Z"></path>
          </svg>
        </div>
        <h2>Verification Failed</h2>
        <p>{{ error }}</p>
        <button @click="goToLogin" class="action-btn secondary">Back to Home</button>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';

export default {
  name: 'EmailVerification',
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();

    const token = route.query.token;
    const loading = ref(true);
    const success = ref(false);
    const error = ref('');

    const goToLogin = () => {
      router.push({ name: 'Home' });
    };

    onMounted(async () => {
      if (!token) {
        error.value = 'No verification token provided.';
        loading.value = false;
        return;
      }

      try {
        await store.dispatch('verifyEmail', token);
        success.value = true;
      } catch (err) {
        error.value = err.message || 'Verification failed.';
      } finally {
        loading.value = false;
      }
    });

    return {
      loading,
      success,
      error,
      goToLogin
    };
  }
};
</script>

<style scoped>
.verification-wrapper {
  position: relative;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}

.verification-card {
  position: relative;
  width: 100%;
  max-width: 480px;
  background: #18181b;
  border: 1px solid #27272a;
  border-radius: 4px; /* Sharp corners */
  padding: 48px 32px;
  text-align: center;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
  z-index: 10;
}

.state-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
}

.icon-circle {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
}

.icon-circle svg {
  width: 40px;
  height: 40px;
}

.icon-circle.success {
  background: rgba(0, 220, 130, 0.1);
  color: #00dc82;
  border: 1px solid rgba(0, 220, 130, 0.2);
}

.icon-circle.error {
  background: rgba(239, 68, 68, 0.1);
  color: #ef4444;
  border: 1px solid rgba(239, 68, 68, 0.2);
}

h2 {
  font-family: 'Space Grotesk', sans-serif;
  font-size: 2rem;
  font-weight: 700;
  margin: 0;
  text-transform: uppercase;
  color: #fff;
}

p {
  color: #a1a1aa;
  line-height: 1.6;
  font-size: 1.05rem;
  margin: 0;
}

.action-btn {
  margin-top: 16px;
  padding: 12px 32px;
  background: #00dc82;
  color: #000;
  border: none;
  border-radius: 4px;
  font-weight: 700;
  cursor: pointer;
  text-transform: uppercase;
  font-size: 0.95rem;
  transition: all 0.2s ease;
}

.action-btn:hover {
  background: #10b981;
  transform: translateY(-2px);
  box-shadow: 0 4px 0 #047857;
}

.action-btn.secondary {
  background: transparent;
  border: 1px solid #3f3f46;
  color: #e4e4e7;
}

.action-btn.secondary:hover {
  border-color: #ef4444;
  color: #ef4444;
  background: rgba(239, 68, 68, 0.1);
  box-shadow: none;
}
</style>